import React, { useState } from "react";
import { PiGraduationCap } from "react-icons/pi";
import { BiBriefcase } from "react-icons/bi";
// import ScrollTrigger from "react-scroll-trigger";

const Education = () => {
  // const [animationOn, setAnimationOn] = useState(false);

  return (
    <div className="education" id="education">
      <h1 className="mainHeading">Education</h1>
      <div className="mainEduContent">
            <div className="education2 animate__animated animate__fadeInLeft">
              <h3 className="mainHeadingEdu">Education</h3>
              <div className="eduCon">
                <div className="educationData">
                  <div className="educationLeft">
                    <PiGraduationCap className="eduIcon" /> <br />
                    <span className="eduLine"></span>
                  </div>
                  <div className="educationRight">
                    <p className="eduData">2014</p>
                    <h4 className="eduTitle">HIGH SCHOOL</h4>
                    <p className="eduPara">
                      High School Diploma – Colombia
                    </p>
                  </div>
                </div>
                <div className="educationData">
                  <div className="educationLeft">
                    <PiGraduationCap className="eduIcon" /> <br />
                    <span className="eduLine"></span>
                  </div>
                  <div className="educationRight">
                    <p className="eduData">2016 - 2021</p>
                    <h4 className="eduTitle">College of Marin, CA</h4>
                    <p className="eduPara">
                      Associate of Science in Mathematics
                    </p>
                  </div>
                </div>
                <div className="educationData">
                  <div className="educationLeft">
                    <PiGraduationCap className="eduIcon" /> <br />
                    <span className="eduLine"></span>
                  </div>
                  <div className="educationRight">
                    <p className="eduData">2021 - 2023</p>
                    <h4 className="eduTitle">UC Santa Cruz, CA</h4>
                    <p className="eduPara">
                      Bachelor’s Degree in Computer Science and Engineering
                    </p>
                  </div>
                </div>
              </div>
            </div>
      </div>
    </div>
  );
};

export default Education;
